Link = require('react-router').Link
RouteHandler = require('react-router').RouteHandler

# Provides global navigation for app e.g. the "Hello | Styleguide" at the top.
module.exports = React.createClass
  displayName: 'HelloWorld'
  render: ->
    React.createElement("div", null,
      React.createElement(RouteHandler, null)
    )

# <header><Link to="index">Index</Link> | <Link to="styleguide">Styleguide</Link></header>



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./site/scripts/app.cjsx
 **/